import { useState } from 'react';
import axios from 'axios';

const projectID = '5700f478-fcb0-43db-b448-c44e124b1a5b';
const PRIVATEKEY = '6c594990-399f-492b-bf51-1a401827fbc4';

const Modal = (props) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  async function AddNewMembers(newuser) {

    const chatRoomIds = [31573, 31574, 31580, 31581, 31582, 31583, 31689]
    const addNewMember = { 'Project-ID': projectID, 'User-Name': "admin", 'User-Secret': "123" };
    let x = 0;

    for (let i = 0; i < chatRoomIds.length; i++) {

      try {
        axios.post(`https://api.chatengine.io/chats/${chatRoomIds[i]}/people/`, {
          username: newuser
        }, { headers: addNewMember }).then(res => {
          x++
        }).catch(err => {
          console.log(err);
        })
      } catch (err) {
        setError('Oops, incorrect credentials.');
      }

      if (x > 6) {
        window.location.reload();
      }

    }

  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const authObject = { 'PRIVATE-KEY': PRIVATEKEY };

    try {
      await axios.post('https://api.chatengine.io/users', {
        username: username,
        secret: password
      }, { headers: authObject }).then(res => {
        AddNewMembers(username);
        localStorage.setItem('username', username);
        localStorage.setItem('password', password);
        props.logedIn();
        setError('');
      });
    } catch (err) {
      setError('Oops, incorrect credentials.');
    }

    // window.location.reload();

  };

  return (
    <div className="wrapper">
      <div className="form">
        <h1 className="title">ලියාපදිංචිවන්න!</h1>
        <form onSubmit={handleSubmit}>
          <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} className="input" placeholder="නම ඇතුළත් කරන්න" required />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input" placeholder="මුරපදය ඇතුළත් කරන්න" required />
          <div align="center">
            <button type="submit" className="button">
              <span>කතාබස් ආරම්භ කරන්න</span>
            </button>
            <span onClick={props.shift} style={{ cursor: 'pointer', marginTop: "30px", color: 'white' }}>ලොග්වීමට මෙතන ක්ලික් කරන්න</span>
            <span style={{ color: 'red', textAlign: "center" }} >{error}</span>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Modal;